import * as $ from 'jquery';

( <any> window ).jQuery = $;
( <any> window ).$ = $;

var ellipsis = require ('jquery-ellipsis');
var dotdotdot = require ('jquery.dotdotdot');

interface EllipsisOptions{
  count? : number;
  type? : string;
}

declare global {
  interface JQuery<TElement = HTMLElement> {
    ellipsis(options?: EllipsisOptions): this;
  }
}

function initNieuwsOverzichtController() {

  if ($(".nieuwsoverzicht").length > 0) {

    var page : number = 0;
    $(".nieuwsoverzicht__item-container h3").ellipsis({count : 2, type : "lines"});
    $(".nieuwsoverzicht__item-container h4").ellipsis({count : 2, type : "lines"});
    $(".nieuwsoverzicht").addClass("nieuwsoverzicht--show");

    let moreArticlesAvailable : boolean = $(".nieuwsoverzicht").attr("data-more-articles-available") === 'true';
    if (typeof moreArticlesAvailable !== undefined) {
      if (moreArticlesAvailable) {
        $(".nieuwsoverzicht__meer-nieuws-laden").click(function (event) {
          event.preventDefault();
            page++;
            const hasQueryParameters = location.href.indexOf("?") >= 0;
            let separator = "?";
            if (!!hasQueryParameters) {
              separator = "&";
            }

            $.ajax({
              url: location.href + separator + "page=" + page
            }).done(function (data : any) {
              let newNode = $(".nieuwsoverzicht__meer-nieuws-laden-row").before($(data).find(".nieuwsoverzicht__page-outer").html());
              moreArticlesAvailable = $(data).find(".nieuwsoverzicht__page-outer").attr("data-more-articles-available") === 'true';
  
              if (!moreArticlesAvailable) {
                $(".nieuwsoverzicht__meer-nieuws-laden-row").remove();
              }
            });
          

          return false;
        });
      } else {
        $(".nieuwsoverzicht__meer-nieuws-laden-container").remove();
      }
    } else {
      $(".nieuwsoverzicht__meer-nieuws-laden-container").remove();
    }
  }

  if ($(".featured-acties__actie-title--ellipsis").length > 0) {
     
    $(".featured-acties__actie-title--ellipsis").dotdotdot({
      ellipsis: "... ",
      watch: "window"
    });
  }

}
export { initNieuwsOverzichtController };